import { Component, Input, OnInit } from '@angular/core';
import { HelpService } from '../help.service';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {

  @Input()
  topic: string;

  constructor(
    private helpService: HelpService
  ) { }

  ngOnInit(): void {
  }

  open($event: Event) {
    $event.stopPropagation();
    this.helpService.open(HELP[this.topic]);
  }

}

const HELP = {
  HOME: '',
  USER_MENU: $localize`#user-menu`,
  ADD_PROJECT: $localize`#add-projects`,
  CHANGE_MAP: $localize`#change-map-visual`,
  VERTEX_BUILDINGS_EDGES: $localize`#vertexes-buildings-and-edges`,
  CREATE_VERTEX: $localize`#createedit-vertexes`,
  CREATE_BUILDINGS: $localize`#createedit-buildings`,
  CREATE_EDGES: $localize`#create-edges`,
  SHOW_LAYERS: $localize`#show-layers`,
  CREATE_NETWORKS: $localize`#create-networks`,
  COVERAGE_AREA: $localize`#coverage-area`,
  TOPOLOGY: $localize`#topology`,
  ARCHITECTURE: $localize`#architecture`,
  ATENUATION: $localize`#atenuation`,
  MATERIALS: $localize`#materials`,
  NETWORK_VALIDATION: $localize`#network-validation`,
  NETWORK_RESULT: $localize`#network-result`,
  LEGEND: $localize`#legend`
};
